import { getImageObjectUrl } from '@/utils/upload/imageObjectUrls';
import { getConfigurationMaskId } from './getConfigurationMaskId';

export function getConfigurationMaskObjectUrl(configurationId: number) {
  return getImageObjectUrl(getConfigurationMaskId(configurationId));
}
